module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a05-cf6530a92ea5b4d38686923ad91440ed.jpg";